import React from 'react';

/**
 * Step block — numbered step with hairline rule, title, and body copy.
 * Stack three of these in a `.oc-grid-3-wide` for the standard pattern.
 */
export default function StepRow({ number, title, children }) {
  return (
    <div>
      <div className="oc-step__numline">
        <span className="oc-step__num">{number}</span>
        <hr className="oc-rule" />
      </div>
      <h4 className="oc-h4" style={{ marginBottom: 8 }}>{title}</h4>
      <p className="oc-body-sm">{children}</p>
    </div>
  );
}
